<template>
	<Loader v-if="loading" />
	<div v-else id="home">
		<Main :updateLoading="updateLoading" />
		<Footer />
	</div>
</template>

<script>
import Main from "../components/Main.vue";
import Footer from "../components/Footer.vue";
import Loader from "../components/Loader.vue";
import { ref } from "vue";

export default {
	name: "Home",
	components: {
		Main,
		Footer,
		Loader,
	},

	setup() {
		const loading = ref(false);
		const updateLoading = (data) => (loading.value = data);
		return { loading, updateLoading };
	},
};
</script>

<style scoped>
* {
	margin: 0;
	padding: 0;
	box-sizing: border-box;
}
#home {
	height: 100vh;
	display: flex;
	flex-direction: column;
	overflow: hidden;
}
</style>
